<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-card
      flat
      min-height="820"
      class="border-radius">
      <v-row style="min-height: 515px;">
        <v-col cols="2" class="text-center pa-0 d-flex">
          <div class="pa-0" style="width: 100%; min-height: 820px;">
            <v-card-text class="py-0 pl-3 pr-0">
              <v-list dense flat class="pa-0" color="#f5f5f5" style="border-radius: 10px;">
                <v-list-item-group
                  v-model="tab"
                  no-action
                  active-class="white--text">
                  <template v-for="(item, index) in menu">
                    <v-list-item :key="index"
                      :class="{
                        'border-item-first': index === 0,
                        'border-item-last': index === 1,
                        'actived': tab === index
                      }">
                      <template v-slot:default="{ active }">
                        <v-list-item-avatar>
                          <v-icon :color="active ? 'white' : 'grey'" small>{{ item.icon }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="text-left text-second caption" :class="active ? 'white--text' : ''">
                            {{ item.label }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <div class="caret" v-if="active"></div>
                      </template>
                    </v-list-item>

                    <v-divider :key="item.value" v-if="index < 1"/>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </div>
        </v-col>
        <v-col cols="10" class="pl-12 py-0">
          <v-card class="box-shadow border-radius px-3" min-height="860">
            <v-card-text>
              <router-view/>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tab: 0,
        menu: [
          {
            label: 'Profil General',
            value: '/profile/owner',
            icon: 'mdi-shield-account-outline',
          },
          {
            label: 'Perusahaan',
            value: '/profile/company',
            icon: 'mdi-home-city-outline'
          }
        ]
      }
    },
    computed: {
      
    },
    watch: {
      'tab': function(val) {
        this.$router.push({ path: `${this.menu[val].value}` })
      }
    },
    mounted () {
      this.tab = this.$route.path === `/profile/owner` ? 0 : this.$route.path === `/profile/company` ? 1 : 2
    },
    methods: {
      
    }
  }
</script>

<style>
.actived {
  background: var(--color-primary);
}
.border-item-first {
  border-radius: 10px 10px 0px 0px !important;
}
.border-item-last {
  border-radius: 0px 0px 10px 10px !important;
}
.caret {
  position: absolute;
  right: 0;
  top: 18px;
  bottom: 18px;
}
.caret:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-left: 10px solid var(--color-primary);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.v-label {
  font-size: 10px !important;
}
</style>